import React, { useContext, } from 'react';

import { PersonalInfo, Field, } from '../../core/inputElements';
import { StepContext, Section, FormContext, } from '../../core/layoutElements';  

const STEPID = "application";
const TITLE = "steps_Particulars";

// const SECTION_APPLICATION = "application";

const Application = (props) => {
    const {formLocalization, } = useContext(FormContext);

    return ( 
        <StepContext.Provider value={{stepId: STEPID, title: TITLE, validations: {}}}>
            <Section id={STEPID} titleText={formLocalization[TITLE]} inline={props.inline} >
                <Field.Label id="notice" label={formLocalization.notice_body()} />
                <Field.Dropdown id="field_CustomerTitle" label={formLocalization.field_CustomerTitle} options={formLocalization.field_CustomerTitle_list} respectValue={formLocalization.field_CustomerTitle_list} required />
                {formLocalization.getLanguage() === "Eng" ? 
                    <><Field.Text id="field_CustomerFirstName" label={formLocalization.field_CustomerFirstName} maxlength={50} required />
                    <Field.Text id="field_CustomerLastName" label={formLocalization.field_CustomerLastName} maxlength={50} required /></>
                :
                    <><Field.Text id="field_CustomerLastName" label={formLocalization.field_CustomerLastName} maxlength={50} required />
                    <Field.Text id="field_CustomerFirstName" label={formLocalization.field_CustomerFirstName} maxlength={50} required /></>
                }
                <PersonalInfo.PhoneFax id="field_TelephoneNo" label={formLocalization.field_TelephoneNo} maxlength={20} />
                <Field.Text id="field_EmailPostal" label={formLocalization.field_EmailPostal} multiline={true} maxlength={60} required />
                <Field.TextArea id="field_Message" label={formLocalization.field_Message} maxlength={300} multiline={true} required />
                <Field.FileUpload id="field_Attachments_1" label={formLocalization.field_Attachments_1} limit={5120*1024} />
                <Field.FileUpload id="field_Attachments_2" label={formLocalization.field_Attachments_2} limit={5120*1024} />
                <Field.FileUpload id="field_Attachments_3" label={formLocalization.field_Attachments_3} limit={5120*1024} />
                <Field.Checkbox id="Privacy" label={formLocalization.acceptPrivacyPolicy()} required />
            </Section> 
        </StepContext.Provider>
    ) 
};

export default {
    stepId: STEPID,
    title: TITLE,
    content: Application,
    focusFirstInput: true,
    validations: {},
};
